import  {impParnellCommon,log,_,mySynchModules,mySynchEnumeration,async,moment} from '../globals';
var config = mySynchModules.config;
class MySynchFactory {
		
		
		
	private $rootScope:any;
	private $window:any;
	private $q:any;
	private $anchorScroll:any;
	private indexedDB:any;
	private constant:any;
	private mySynchConstantService:any;
	private activeFarm:any = {};
    private availableFarms:any = [];
	private activeHerd:any =  {};
	private availableHerds:any = [];
	private additionalHerdData:any = [];
	private activeHerdFertilityProgram:any = {};
	private activeFarmTerritoryManager:any = config.default.territoryManager;
	private notifyFunc:Function =  _.curry((type:any, message:any) => {
										this.$rootScope.$broadcast('message:notification', {type: type, message: message});

										return message;
									});
	private confirmationFunc:Function = _.curry((type:any,message:any,useTimeout:any) =>{
										this.$rootScope.$broadcast('message:notification', {type: type, message: message, useTimeout: useTimeout});
										return message;
									});
	private mySynchDataStore:any;
	private broadCastSrv:any;

	state:any;
	api:any;
	cookies:any;
	viewAuth:any;
	mySynchEnumSvc:any;
	i18n:any;
	util:any = impParnellCommon.util;
	lists:any = {parityType: [
		{
			parityTypeId: 1,
			name: 'Heifer',
			abbr: 'heifer'
		}, {
			parityTypeId: 2,
			name: 'Lactation 1',
			abbr: 'lactation1'
		}, {
			parityTypeId: 3,
			name: 'Lactation 2+',
			abbr: 'lactation2'
		}
	]};
	previousState:any = undefined;
	colorComponents:any = [
							{
								name:		'primary',
								color:		'blue',
								fillColor:	'rgb(51, 122, 183)',
								strokeColor: 'rgb(46, 109, 164)',
								highlightFill: 'rgb(40, 96, 144)',
								highlightStroke: 'rgb(32, 77, 116)'
							},
							{
								name:		'danger',
								color:		'red',
								fillColor:	'rgb(217, 83, 79)',
								strokeColor: 'rgb(212, 63, 58)',
								highlightFill: 'rgb(201, 48, 44)',
								highlightStroke: 'rgb(172, 41, 37)'
							},
							{
								name:		'success',
								color:		'green',
								fillColor:	'rgb(92, 184, 92)',
								strokeColor: 'rgb(76, 174, 76)',
								highlightFill: 'rgb(68, 157, 68)',
								highlightStroke: 'rgb(57, 132, 57)'
							},
							{
								name:		'warning',
								color:		'orange',
								fillColor:	'rgb(240, 173, 78)',
								strokeColor: 'rgb(238, 162, 54)',
								highlightFill: 'rgb(236, 151, 31)',
								highlightStroke: 'rgb(213, 133, 18)'
							},
							{
								name:		'',
								color:		'purple',
								fillColor:	'rgb(162, 90, 197)',
								strokeColor: 'rgb(141, 78, 173)',
								highlightFill: 'rgb(122, 20, 173)',
								highlightStroke: 'rgb(122, 20, 173)'
							},
							// MySynch standard data-chart colors
							{
								name:		'insemination',
								color:		'my-tan',
								fillColor:	'#FFBB5F',
								strokeColor: '#FFBB5F',
								highlightFill: 'rgb(40, 96, 144)',
								highlightStroke: 'rgb(32, 77, 116)'
							},
							{
								name:		'conception',
								color:		'blue-steel',
								fillColor:	'#337ab7',
								strokeColor: '#337ab7',
								highlightFill: 'rgb(40, 96, 144)',
								highlightStroke: 'rgb(32, 77, 116)'
							},
							{
								name:		'pregnancy',
								color:		'my-light-green',
								fillColor:	'#7AB85C',
								strokeColor: '#7AB85C',
								highlightFill: 'rgb(40, 96, 144)',
								highlightStroke: 'rgb(32, 77, 116)'
							},
							{
								name:		'pregnancyRha',
								color:		'my-dusty-rose',
								fillColor:	'#C66376',
								strokeColor: '#C66376',
								highlightFill: 'rgb(40, 96, 144)',
								highlightStroke: 'rgb(32, 77, 116)'

							}
						];
	unsavedChangesConfirmationMessage:any = 'Your most recent changes have not been saved. If you leave before saving, your changes will be lost. \n\nAre you sure you want to leave this page?';

	
	
	// view section/order definition for fertility protocols by protocol code
	fertilityProtocolOptionViewDefinition:any = { //TODO revisit having this here once we start updating the DB structure
		preSynch: {
			header: 'PreSynch',
			codes: ['BP63', 'BP64', 'BP65']
		},
		ovsynchResynch: {
			header: 'OVsynch/Resynch',
			codes: ['BP07', 'BP08', 'BP50', 'BP24', 'BP28', 'BP09', 'BP29', 'BP41', 'BP42', 'BP25', 'BP67', 'BP68', 'BP53', 'BP54', 'BP55', 'BP56', 'BP57', 'BP58', 'BP59', 'BP60', 'BP61', 'BP62']
		},
		other: {
			header: 'Other',
			codes: ['HD', 'BP05', 'BP06', 'BP46', 'BULL']
		}
	};
	postLoginApiFunctions:any = {
		//	this should assign all the 'Type's from the database to MSF.lists
		getStaticListData: (done:Function) => {
			//console.log('### calling getStaticListData in postLoginApiFunctions ####');	
			if (window.navigator.onLine) {
			this.api.getStaticListData((err:any, data:any) => {
					if (err || _.isUndefined(data)) {
						log.error('error getting static list data: ' + err);

						return done(err || 'unspecified error');
					}

				
					// var stringCodeFile = JSON.stringify(data.codeFile);
					// localStorage.setItem(this.constant.codeFile, stringCodeFile);
					_.assign(this.lists, data);
					
					this.decorateListData();

					done(null,null);
				});
				
			} else {
				done(null,null);		
			}
		},
		refreshMysynchEnumerations: ["getStaticListData", (done:Function,results:any) => {
			//console.log('### calling refreshMysynchEnumerations in postLoginApiFunctions ####');
			if (window.navigator.onLine) {
				this.mySynchEnumSvc.refreshMySynchEnumerations().then((enumerations:any) => {
					done(null,null);
				});
			}else{
				done(null,null);
			}
		}],
		getFarmsByPersonId: ["refreshMysynchEnumerations", (done:Function,results:any) => {
			if (window.navigator.onLine) {
				this.api.getFarmsByPersonId(this.cookies.user.PersonId, (err:any, data:any) => {
					if (err) {
						log.error('error getting farms by personId: ' + err);

						return done(err, null);
					}

					
					var sorted = this.getSortedListOfAvailableFarms(data);
					
					this.setAvailableFarms(sorted);
					

					this.refreshPersmissionsAndRoles();

					this.lists.availableFarms = sorted;
					
					done(null, data);
				});
			} else {
				var sorted = JSON.parse(localStorage.getItem(this.constant.availableFarms));
				this.lists.availableFarms = sorted;
				done(null, sorted);
			}
		}],
		getHerdsByFarmIds: ['getFarmsByPersonId', (done, results) => {
			var farms = results.getFarmsByPersonId;
			var farmIds = _.map(farms,(farm)=>{return {farmId:_.get(farm,'farmId')}});
			if (window.navigator.onLine) {
				this.api.getHerdsByFarmIds(JSON.stringify(farmIds), (err, herdData) => {
					if (err) {
						log.error('error getting farms by personId: ' + err);

						return done(err,null);
					}
				
					this.setAvailableHerds(herdData);

					done(null, herdData);
				});
			} else {
				var sorted  = this.getAvailableHerds();
				this.lists.availableHerds = sorted;

				done(null, sorted);
			}
		}],
		getAdditionalHerdData: ['getHerdsByFarmIds', (done, results) => {
			if(window.navigator.onLine){
             this.updateAdditionalHerdDData().then((data)=>{
			 	done(null,data);
			 });
			}else{
				var additionalHerdData = this.getAdditionalHerdData();
				var sortedAdditionalHerdData = _.sortBy(additionalHerdData, 'herdId');
				this.lists.additionalHerdData = sortedAdditionalHerdData;
				done(null, sortedAdditionalHerdData);
			}
		}],
		getActiveFarm: ['getFarmsByPersonId', (done, results) => {
			var farms = results.getFarmsByPersonId;

			if (_.isEmpty(farms)) {
				this.setActiveFarm(null);

				return done(null, null);
			}

			var farmInCookie			= this.getActiveFarm() || {};
			var activeFarmCookieInFarms = _.find(farms, {farmId: farmInCookie.farmId});
			var farm					= activeFarmCookieInFarms || farms[0];

			if(!_.has(farm,'herds')){
                  this.api.getHerdsByFarmId(_.get(farm,'farmId'), (err, herds) => {
					if (err) {
						log.error('error getting herds by farmId in MSF->postLoginApiFunctions->getActiveFarm: ' + err);

						this.setActiveFarm(farm);
						this.setPermissionsAndRoles();
			
						done(null, farm);
					}
                    if(!_.isUndefined(herds) && !_.isNull(herds) && !_.isEmpty(herds)){
						_.set(farm,'herds',herds);
					}
					this.setActiveFarm(farm);
					this.setPermissionsAndRoles();
					done(null, farm);

				});
			}else{
				this.setActiveFarm(farm);
				this.setPermissionsAndRoles();
	
				done(null, farm);
			}
		
		}],

		getTerritoryManagerByFarmId: ['getActiveFarm', (done, results) => {
			var farm = results.getActiveFarm;
			this.getTerritoryManagerForFarm(done, farm);
		}],
		getHerdsByFarmId: ['getActiveFarm', (done, results) => {
			var farm = results.getActiveFarm;

			if (_.isEmpty(farm)) {
				this.setActiveHerd(null);

				return done(null, []);
			}

			if (window.navigator.onLine) {
				this.api.getHerdsByFarmId((this.getActiveFarm() || {}).farmId, (err, data) => {
					if (err) {
						log.error('error getting herds by farmId: ' + err);

						return done(err);
					}

					(this.getActiveFarm() || {}).herds = data;

					if (data && data.length) {
						this.setActiveHerd(data[0]);
					} else {
						this.setActiveHerd(null);
					}

					var objectStoreNameApi = {'data': data, 'tableName' : this.constant.getHerdsByFarmId, 'keyId' : 'herdId'};
					this.indexedDB.createObjectStore(this.constant.getHerdsByFarmId, objectStoreNameApi);
					this.indexedDB.writeData(this.constant.getHerdsByFarmId, objectStoreNameApi);

					done(null, data);
				});
			} else {
				this.indexedDB.readData(this.constant.getHerdsByFarmId, this.constant.getHerdsByFarmId,(err, data) =>{
					if (err) {
						console.log('err', err);
					}
					if (data && data.length) {
						(this.getActiveFarm() || {}).herds = data;

						if (data && data.length) {
							this.setActiveHerd(data[0]);
						} else {
							this.setActiveHerd(null);
						}

						done(null, data);
					}
				});
			}
		}]
	};

	notify:any = {
		info:	    this.notifyFunc('info'),
		success:	this.notifyFunc('success'),
		warning:	this.notifyFunc('warning'),
		danger:		this.notifyFunc('danger')
	};

	confirmation:any = {
		info:		this.confirmationFunc('info'),
		success:	this.confirmationFunc('success'),
		warning:	this.confirmationFunc('warning'),
		danger:		this.confirmationFunc('danger')
	};

	listsToInitialize:any = [
		'availableFarms','availableHerds', 'activitySubType', 'activityType', 'aiType', 'breedName', 'diagnosisType',
		'eventType', 'fertilityProgramDefinedSequence', 'fertilityProgramFrequencyType',
		'fertilityProgramPregnancyCheckFrequencyType', 'fertilityProgramType',
		'herdEventType','herdSoftwareType', 'identificationType', 'itemType',
		'journalCategory', 'measurementType', 'missingRuleType',
		'personType', 'productType','reportSection', 'reportLineItem', 'reproductiveProtocolAlternativeType',
		'reproductiveProtocolRule', 'reproductiveProtocolSequence', 'roleType',
		'selectionConstraintType', 'stateType', 'statusType',
		'timeConstraintType', 'unitType', 'uploadStatusType', 'weekdayType','personTM','personActiveFarmAdmins','appLevelNotifications',
		'csvFileLookup','groupTypeMembers','herdFertilityCalendarItemList'
	];

	msfReady:any;

	multiFarmStates:any = ["MultiFarmDashboard"];
	adminStates:any = ["AdminUserManagement","AdminUserManagementMaint","FarmManagement","FarmManagementMaint","TerritoryDashboard","NewFarm"];
	urlGAStates:any = ["Fertility360report","PublishedReport","EvaluationOverview","ResultWriteReport","ReviewDraftReport","SectionPage","LamenessScoring","BodyConditionScoring"];

	static $inject = ['$state','$rootScope','$window','$q','$anchorScroll','ApiFactory','CookieFactory','ViewAuthorizationFactory','IndexedDBFactory','F360Constant','mySynchDataStore','broadCastService','mySynchEnumerationService','mySynchConstantService'];
	constructor($state, $rootScope, $window, $q, $anchorScroll, api, cookies, viewAuth, indexedDB, constant,mySynchDataStore,broadCastSrv,mySynchEnumSvc,mySynchConstantService) {
		
		this.state = $state;
		this.$rootScope = $rootScope;
		this.$window = $window;
		this.$q = $q;
		this.$anchorScroll = $anchorScroll;
		this.api = api,
		this.cookies = cookies;
		this.viewAuth = viewAuth;
		this.indexedDB = indexedDB;
		this.constant = constant;
		this.mySynchConstantService = mySynchConstantService;
		this.i18n = impParnellCommon.i18n;
		this.mySynchDataStore = mySynchDataStore;
		this.broadCastSrv = broadCastSrv;
        this.mySynchEnumSvc = mySynchEnumSvc;

		_.forEach(this.listsToInitialize, (listName) => {
			this.lists[listName] = [];
		});

		this.initialize();
		
	}

	private initialize() {
		
		
	  this.msfReady = this.$q((resolve, reject) => {
								// clean up localStorage items that are no longer used
								this.cleanUpLocalStorage();

								var activeUser = this.getActiveUser();

								if (this.viewAuth.checkUser() && !_.isUndefined(_.get(activeUser,'PersonId'))) {
										// if the user is already logged in , we can update the datastore with the user info
										this.mySynchDataStore.onUserChanged(activeUser);

									var apiFunctions = {};

    								apiFunctions = _.extend(apiFunctions, this.postLoginApiFunctions);

									async.auto(apiFunctions, (err, results) => {
										if (err) {
											this.loadPage('Error');
	
											return; // rejecting the defferred was causing all of the 'Then' blocks to execute
										}
	
										if(!_.isEmpty(this.cookies.user) && !_.isUndefined(this.cookies.user)){
											this.mySynchDataStore.onUserChanged(this.cookies.user);
										}
										if (this.viewAuth.checkUser() && _.isEmpty(_.get(this.state,"current.name",""))) {
											var optionalParams = {};
											var rolesByFarm = _.get(this.cookies.user,'rolesByFarm',[]);
											var isTM = _.any(rolesByFarm,(role)=>{
												return _.contains(_.keys(role),this.mySynchEnumSvc.getMySynchEnumerationName("Role","TERRITORY_MANAGER"));
												});
											// if the user is a territory manager, we need to supply the default tab name of the territory dashboard
											if (isTM) {
												_.set(optionalParams,'selectedTabName',this.mySynchConstantService.defaultTerritoryManagerDashboardTab);
											}    
											
											var homePageStateName = this.getUserHomepageStateName(true);
												this.loadPage(homePageStateName,optionalParams);
												//	results should be [undefined, undefined]
												resolve(results);
											
										}else{
												//	results should be [undefined, undefined]
												resolve(results);
										}
	
										
									});
								}else{
									resolve(null);		
								}

								
							});

		this.$rootScope.$on('farm:changed', () => {
			console.log('MSF: farm changed');
			async.auto({
				updateTerritoryManager: (done) => {
					var farm = this.getActiveFarm();
					this.getTerritoryManagerForFarm(done, farm);
				}
			}, () => {
				this.setPermissionsAndRoles();

				this.$rootScope.$broadcast('permission:changed');
			});
		});


	}

	private cleanUpLocalStorage() {
		// localStorage items no longer used
		var localStorageItems = [
			this.constant.availableFarms,
			this.constant.availableHerds,
			this.constant.codeFile,
			this.mySynchConstantService.additionalHerdData
		];
		_.forEach(localStorageItems, (item) => {
			localStorage.removeItem(item);
		});
	}
	  
	 
		private setPermissionsAndRoles() {
			var permissions		= _.get(this.cookies, 'user.permissionsByFarm',	{});
			var roles			= _.get(this.cookies, 'user.rolesByFarm',		{});
			var activeFarmId	= (this.getActiveFarm() || {farmId: 0}).farmId;

			_.set(this.cookies, 'user.permissions',	_.extend({}, permissions[activeFarmId],	permissions['0']));
			_.set(this.cookies, 'user.roles',		_.extend({}, roles[activeFarmId],		roles['0']));
			this.cookies.save();
		}

		private setPermissionsAndRolesForFarm(farm){
			var permissions		= _.get(this.cookies, 'user.permissionsByFarm',	{});
			var roles			= _.get(this.cookies, 'user.rolesByFarm',		{});
			
			var farmId = _.get(farm,'farmId') as number;
			_.set(this.cookies, 'user.permissions',	_.extend({}, permissions[farmId],	permissions['0']));
			_.set(this.cookies, 'user.roles',		_.extend({}, roles[farmId],		roles['0']));
			this.cookies.save();
		}
		private removePermissionsAndRolesForFarm(farmId){
                _.set(this.cookies,'user.permissionsByFarm',_.omit(_.get(this.cookies, 'user.permissionsByFarm',[farmId])))
				_.set(this.cookies,'user.rolesByFarm',_.omit(_.get(this.cookies, 'user.rolesByFarm',[farmId])))
		}


		private getTerritoryManagerForFarm(done, activeFarm) {
			if (_.isEmpty(activeFarm) || activeFarm.farmId === null || activeFarm.farmId === undefined) {
				return done(null, []);
			}

			if (window.navigator.onLine) {
				this.api.getTerritoryManagerByFarmId(activeFarm.farmId, (err, data) => {
					if (err) {
						log.error('error getting territory manager by farmId: ' + err);

						return done(err);
					}

					var objectStoreNameApi = {'data': data, 'tableName' : this.constant.getTerritoryManagerForFarm, 'keyId' : 'personId'};
					this.indexedDB.createObjectStore(this.constant.getTerritoryManagerForFarm, objectStoreNameApi);
					this.indexedDB.writeData(this.constant.getTerritoryManagerForFarm, objectStoreNameApi);

					if (data && data.length) {
						var territoryManager = data[0];
						this.setActiveFarmTerritoryManager({name: territoryManager.firstName + ' ' + territoryManager.lastName, phone: territoryManager.mobilePhone, email: territoryManager.email});
					}

					done(null, data);
				});
			} else {
				this.indexedDB.readData(this.constant.getTerritoryManagerForFarm, this.constant.getTerritoryManagerForFarm, (err, data) =>{
					if (err) {
						console.log('err', err);
					}
					if (data && data.length) {
						var territoryManager = data[0];
						this.setActiveFarmTerritoryManager({name: territoryManager.firstName + ' ' + territoryManager.lastName, phone: territoryManager.mobilePhone, email: territoryManager.email});

						done(null, data);
					}
				});
			}		
		}

		

		private getFertilityProtocolViewInfoByCode(code) {
			var fpovd = this.fertilityProtocolOptionViewDefinition;
			function matchesCode(headerCode) {
				return headerCode === code;
			}

			if (_.any(fpovd.preSynch.codes, matchesCode)) {
				return {header: fpovd.preSynch.header, displayOrderIndex: fpovd.preSynch.codes.indexOf(code)};
			} else if (_.any(fpovd.ovsynchResynch.codes, matchesCode)) {
				return {header: fpovd.ovsynchResynch.header, displayOrderIndex: fpovd.ovsynchResynch.codes.indexOf(code)};
			} else {
				return {header: fpovd.other.header, displayOrderIndex: fpovd.other.codes.indexOf(code)};
			}
		}

		private decorateListData() {
			_.forEach(this.lists.fertilityProgramType, (fp) => {
				_.assign(fp, this.getFertilityProtocolViewInfoByCode(fp.code));
			});
		}
		// parses the detailsJson property of codeFile items and returns the updated
		// codeFile array
		private parseCodeFileDetailsJson(codeFileArray = []){
			_.forEach(codeFileArray, (codeFileItem) =>{
				var details = {};   
				if(_.has(codeFileItem,'detailsJson')){
					  
					  var detailsJsonValue = _.get(codeFileItem,'detailsJson','{}');
					 if(_.isString(detailsJsonValue)){
									
						try{

							detailsJsonValue = JSON.parse(detailsJsonValue);
							
						}catch(e){
							log.warn("failed to parse a code file item's details json: "+_.get(e,'message',''));
							log.warn(codeFileItem);
						}
					}
					_.isArray(detailsJsonValue) ?  _.assign(details,detailsJsonValue[0]) : _.assign(details,detailsJsonValue);
				}
				_.set(codeFileItem,'detailsJson',details);
			});
			return codeFileArray;
		}

		
		private buildPBIServicesUrl(){
			var pbiServerUrl = "";
			var apiServerUrl = _.get(this.api,'apiServerUrl',"");
			
			if(_.contains(apiServerUrl,'mysynchservices.')){
				pbiServerUrl = "https://mysynchpbiservices-prod.azurewebsites.net";
			}
			
			if(_.contains(apiServerUrl,'mysynchservicesstage.')){
				pbiServerUrl = "https://mysynchpbiservices-stage.azurewebsites.net";
			}

			if(_.contains(apiServerUrl,'mysynchservicestest.')){
				pbiServerUrl = "https://mysynchpbiservices-test.azurewebsites.net";
			}
			if(_.contains(apiServerUrl,'localhost')){
				pbiServerUrl = "https://mysynchpbiservices-stage.azurewebsites.net";
			}
			return pbiServerUrl;
		}
		private buildEnvironmentName(){
			var envName = "LOCAL";
			var apiServerUrl = _.get(this.api,'apiServerUrl',"");

			if(_.contains(apiServerUrl,'mysynchservices.')){
				envName = "PROD";
			}
			
			if(_.contains(apiServerUrl,'mysynchservicesstage.')){
				envName = "STAGE";
			}

			if(_.contains(apiServerUrl,'mysynchservicestest.')){
				envName = "TEST";
			}
			if(_.contains(apiServerUrl,'mysynchservicesdev.')){
				envName = "DEV";
			}
			return envName;
		}

		getLocalDevWatcherCount(): number {
			const root = angular.element(document.getElementsByTagName('body'));
			const watchers: any[] = [];

			function getWatchers(element: Element) {
				const scope = angular.element(element).scope();
				if (scope && (scope as any).$$watchers) {
				watchers.push(...(scope as any).$$watchers);
				}
				Array.from(element.children).forEach(child => getWatchers(child));
			}

			getWatchers(root[0]);
			return watchers.length;
		}

		 getScopeCount(): number {
			const root = angular.element(document.getElementsByTagName('body'));
			const scopeCount = new Set();

			function countScopes(element: Element) {
				const scope = angular.element(element).scope();
				if (scope) scopeCount.add(scope);
				Array.from(element.children).forEach(child => countScopes(child));
			}

			countScopes(root[0]);
			return scopeCount.size;
		}

		
		getActiveHerdDateFormat(){
			var currentActiveHerdId = _.get(this.getActiveHerd(), 'herdId');
			var currentActiveHerdAdditionalHerdData = this.getAdditionalHerdDataItem(currentActiveHerdId);
			var herdDateFormat = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.dateFormat',this.mySynchConstantService.defaultShortDateFormat);
			
			return herdDateFormat;
		}
		getActiveHerdTimeFormatWithLongDigitYear(){
		    var herdDateFormat = this.getActiveHerdDateFormat();
			// Since the format stored comes from matching what dairy comp 305 uses, we need to adjust the year from 2 digits to 4
			var herdDateFormatParts = herdDateFormat.split('/');
			if (_.trim(herdDateFormatParts[2]).length === 2) {
				herdDateFormatParts[2] = herdDateFormatParts[2]+"YY";
				herdDateFormat = herdDateFormatParts.join('/');
			}
			return herdDateFormat;
		}
		// function that returns the short format of a date and time string for a given date string based on the active herd's date format
		getActiveHerdDateTimeFormat(){
			var dateFormat = this.getActiveHerdTimeFormatWithLongDigitYear();
			var timeFormat = this.mySynchConstantService.defaultTimeFormat;
			var dateTimeFormat = dateFormat + " " + timeFormat;
			return dateTimeFormat;
		}
		// function that returns a datetime string for a given date string using the active herd's short date format
		getFormattedActiveHerdDateTimeString(dateString){
			var dateTimeString = ""
			if(!_.isUndefined(dateString) && !_.isNull(dateString)){
				var format = this.getActiveHerdDateTimeFormat();
				var dateTimeString = moment(dateString).format(format);
			}
			return dateTimeString;
		}
		//function that returns the long format of a date string for a given date string
		getLongDateFormatFromMetaFormatString(metaDateFormatString,seperator){
			var dataFormatParts = metaDateFormatString.split(seperator);

			if(_.contains(dataFormatParts[0],'D')){
				return this.mySynchConstantService.dateFormats.canada.dateLong;
			}else if(_.contains(dataFormatParts[0],'M')){
				return this.mySynchConstantService.dateFormats.usa.dateLong;
			}
		}

		//function that returns a long formatted date string for a given date string
		getFormattedLongDateString(dateString){
			var formattedLongDateString = "";
			if(!_.isUndefined(dateString) && !_.isNull(dateString)){				
				var metaDateFormatString = this.getActiveHerdDateFormat();
				var longDateFormat = this.getLongDateFormatFromMetaFormatString(metaDateFormatString,this.mySynchConstantService.defaultDateSeparator);
				var formattedLongDateString = moment(dateString).format(longDateFormat);
			}
			return formattedLongDateString;
		}

		//function that returns a long formatted date string with a day of week prefix for a given date string
		getFormattedLongDateStringWithDayOfWeek(dateString){
			var formattedLongDateString = "";
			if(!_.isUndefined(dateString) && !_.isNull(dateString)){
				var metaDateFormatString = this.getActiveHerdDateFormat();
				var longDateFormat = this.getLongDateFormatFromMetaFormatString(metaDateFormatString,this.mySynchConstantService.defaultDateSeparator);
				var formattedLongDateString = moment(dateString).format('dddd '+longDateFormat);
			}
			return formattedLongDateString;
		}

		getMySynchStringDayOfWeek(dayOfWeekNumber, length = "short")
		{
			var shortDaysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
			var longDaysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

			if(length === "short"){
				return shortDaysOfWeek[dayOfWeekNumber - 1];
			}else{
				return longDaysOfWeek[dayOfWeekNumber - 1];
			}
		}

		getFullUrlWithParams(urlTemplate,params){
			var url = (!_.isUndefined(urlTemplate) && !_.isNull(urlTemplate)) ? urlTemplate : "";
			if(!_.isUndefined(params) && _.isObject(params) && !_.isEmpty(urlTemplate)){
				var paramNames = _.keys(params);
				_.forEach(paramNames,(paramName)=>{
					url = url.replace(":"+paramName,params[paramName]);
				});
			}
			return url;
		}
        sleep(ms) {
			return new Promise(resolve => setTimeout(resolve, ms));
		  }  
		waitForElm(selector) {
			
			return new Promise(resolve => {
				if (document.querySelector(selector)) {
					return resolve(document.querySelector(selector));
				}
		
				const observer = new MutationObserver(mutations => {
					if (document.querySelector(selector)) {
						resolve(document.querySelector(selector));
						observer.disconnect();
					}
				});
		
				observer.observe(document.body, {
					childList: true,
					subtree: true
				});
			});
		}
        // function that is used as a temp fix for the issue where some variables are not being updated in the angular digest cycle
		triggerAngularDigestCycleRefresh(){
             // triggering a click event on the mainAppContainer id element to force the angular digest cycle to refresh
			 $("#mainAppContainer").trigger("click");
		}

		// function that toggles a boostrap collapse given a target element id
		toggleCollapse(controlElement,targetId){
			if($(controlElement).hasClass('isCollapsed')){
				$(controlElement).removeClass('isCollapsed');
			}else{
				$(controlElement).addClass('isCollapsed');
			}
			$('#'+targetId).collapse('toggle');
		}

		// function that checks if a variable reference has a value and not undefined, empty or null
		hasValue(value){
			if(_.isBoolean(value) || _.isNumber(value)){
				return !_.isUndefined(value) && !_.isNull(value) 
			  }else{
				return !_.isUndefined(value) && !_.isNull(value) && !_.isEmpty(value);
			  }
		 }
		 isNullish(value){
			var hasNoValue = false;
			if(_.isUndefined(value) || _.isNull(value)){
				hasNoValue = true; 
			}
			return hasNoValue;
		  }

		  isSameString(string1, string2){
			if(!_.isString(string1) || !_.isString(string2)){
				return false;
			}
		    // first trim and lowercase both strings 
			let comparedString1 = _.trim(string1).toLowerCase();
		    let comparedString2 = _.trim(string2).toLowerCase();

			// then remove all spaces from both strings
			comparedString1 = this.removeSpacesFromString(comparedString1);
			comparedString2 = this.removeSpacesFromString(comparedString2);

			return comparedString1 === comparedString2;
		  }

		  getCleanedString(string){
			if(!_.isString(string)){
				return string;
			}
			// first trim extra spaces
			let cleanedString = _.trim(string);
			// then remove extra spaces within the string leaving only single spaces between words
			cleanedString = cleanedString.replace(/\s+/g, ' ');
			return cleanedString;
		  }
		   
		
			refreshStaticLists(){
				if (window.navigator.onLine) {
					this.api.getUnCachedStaticListData((err, data) => {
						if (err || _.isUndefined(data)) {
							log.error('error getting uncached static list data: ' + err);

							return !_.isUndefined(err) ? err : 'unspecified error';
						}


						_.assign(this.lists, data);
							
						this.decorateListData();
		   
					});
				}
				
			};
			
			encodeBase64StringForUrl(base64String){
				return base64String.replace(/\+/g, '-').replace(/\//g, '_');
			}
			decodeBase64StringFromUrl(base64String){
				return base64String.replace(/-/g, '+').replace(/_/g, '/');
			}

			safeGetParsedJson(jsonString){
				// an empty object is used here as a default value 
				// but parsedJson could end up being an array based on jsonString
				var parsedJson = {};
				try{
					parsedJson = JSON.parse(jsonString);
				}catch(e){
					log.error("error parsing json string in MSF->safeGetParsedJson: "+_.get(e,'message',''));
				}
				return parsedJson;
			}
			// function that takes a string and an array of characters including spaces and removes them from the string globally
			removeCharactersFromString(string,characters){
				var newString = string;
				_.forEach(characters,(character)=>{
					// remove all instances of the character from the string with the global flag
					newString = newString.replace(new RegExp(character, 'g'), '');
				});
				return newString;
			}
			
			
			removeSpacesFromString(string){
				return string.replace(/\s/g,'');
			}
			
			getCodeFileSubsetWithParsedDetailsJson(codeFileArray){
				var parsedCodeFile = this.parseCodeFileDetailsJson(codeFileArray);

				return parsedCodeFile;

			};
			getCodeFileCodeValueByCodeTypeAndCode(codeType,code){
				var codeFileItem = _.find(this.lists.codeFile,{codeType: codeType, code: code});
				var codeValue = _.get(codeFileItem,'codeValue',code);
				return codeValue;
			}

			getMeasurementStandardReplacementText(standard,text){
				var measurementStandards = _.filter(this.lists.codeFile,{codeType: "MEASUREMENTSTANDARD"});
				var parsedMeasurementStandards = this.getCodeFileSubsetWithParsedDetailsJson(measurementStandards);

				var measurementStandard = _.find(parsedMeasurementStandards,{code: standard});
				
				if(!_.isUndefined(measurementStandard)){
					// length 
					var lengthLookups = _.get(measurementStandard,'detailsJson.measurements.length.lookups',[]);
					_.forEach(lengthLookups,(lookup) =>{
						 if(_.includes(text,lookup.lookupValue)){
							 text = text.replace(lookup.lookupValue,lookup.returnValue);
						 }
					});	

					// weight 
					var weightLookups = _.get(measurementStandard,'detailsJson.measurements.weight.lookups',[]);

					_.forEach(weightLookups,(lookup) =>{
						if(_.includes(text,lookup.lookupValue)){
							text = text.replace(lookup.lookupValue,lookup.returnValue);
						}
				   });	
				}

				return text;
			};

			getMeasurementStandardUnitByMeasurementType(standard,measurementType){
				var measurementStandards = _.filter(this.lists.codeFile,{codeType: "MEASUREMENTSTANDARD"});
				var parsedMeasurementStandards = this.getCodeFileSubsetWithParsedDetailsJson(measurementStandards);

				var measurementStandard = _.find(parsedMeasurementStandards,{code: standard});
				
				var measurementUnit = "";
				if(!_.isUndefined(measurementStandard)){
				   measurementUnit = _.get(measurementStandard,'detailsJson.measurements.'+measurementType+'.unit',"");
				}

				return measurementUnit;
			};
			 
			// function that takes in a data type and a string value and returns the appropriate data type value
			getDataTypeValueFromString(dataType:string,value:string){
				if(!this.hasValue(value) || !this.hasValue(dataType) ||  _.isString(value) === false){
					return value;
				}
			
				var dataTypeValue: string|number|boolean = value;

				if(dataType.toLowerCase() === "number"){
					dataTypeValue = Number(value);
				}else if(dataType.toLowerCase() === "boolean"){
					dataTypeValue = value.toLowerCase() === "true" ? true : false;
				}
				return dataTypeValue;
			}
			// function that takes a JSON object string and an error message and returns the parsed JSON or an empty object
			parseJsonStringToObject(jsonString,errorMessage){
				var parsedJson = {};
				try{
					parsedJson = JSON.parse(jsonString);
				}catch(e){
					log.error(errorMessage);
				}
				return parsedJson;
			};
			// function that takes a JSON array string and an error message and returns the parsed JSON array or an empty array
			parseJsonStringToArray(jsonString,errorMessage){
				var parsedJson = [];
				try{
					parsedJson = JSON.parse(jsonString);
				}catch(e){
					log.error(errorMessage);
				}
				return parsedJson;
			};
			// function that gets a code file item from mysynch factory's lists.codeFile by code and codeType with its detailsJson property parsed
			getParsedCodeFileItemByCodeAndCodeType(codeType,code) {
				var parsedCodeFileItem = undefined;
				var codeFileListItem = _.find(_.get(this.lists,'codeFile',[]), {code: code, codeType: codeType});
				if(!_.isUndefined(codeFileListItem)){ 
				  try {
					parsedCodeFileItem = _.cloneDeep(codeFileListItem);
					var codeFileItemDetailsJson = _.get(parsedCodeFileItem,'detailsJson','{}');
					var codeFileItemDetails = _.get(JSON.parse(codeFileItemDetailsJson),'[0]',{});
					_.set(parsedCodeFileItem,'details',codeFileItemDetails);
				  } catch (error) {
					 console.log(`!!!! error parsing code file item details json in MSF->getParsedCodeFileItemByCodeAndCodeType codeType:${codeType} code: ${code} !!!!!`);
				  }
				}
				return parsedCodeFileItem
			}

			refreshPersmissionsAndRoles(){
				var personId = _.get(this.cookies,'user.PersonId');
				this.api.getFarmPermissionsByPersonId(personId,(err, results)=>{
				   
				   var permissionsByFarm = _.get(results,'permissionsByFarm');
				   var rolesByFarm = _.get(results,'rolesByFarm');
				   if(!_.isUndefined(permissionsByFarm) && !_.isUndefined(rolesByFarm)){
						_.set(this.cookies,'user.permissionsByFarm', permissionsByFarm);
						_.set(this.cookies,'user.rolesByFarm', rolesByFarm);

						this.setPermissionsAndRoles();
				   }else{
					 console.log("!!!! permissionsByFarm or rolesByFarm was null in refreshPersmissionsAndRoles !!!!!");
				   }
				})
			};

			getActiveFarmTerritoryManager() {
				return this.activeFarmTerritoryManager;
			};

			setActiveFarmTerritoryManager(territoryManager) {
				var tm = {
					name: territoryManager	&& territoryManager.name	? territoryManager.name		: config.default.territoryManager.name,
					phone: territoryManager && territoryManager.phone	? territoryManager.phone	: config.default.territoryManager.phone,
					email: territoryManager && territoryManager.email	? territoryManager.email	: config.default.territoryManager.email
				};
				this.activeFarmTerritoryManager = tm;
			};

			setActiveFarm(farm,doNotBroadcast = false) {
				this.cookies.state.activeFarm = farm;
				this.cookies.save();
				this.updateAvailableFarmListOption(farm);
				this.mySynchDataStore.setActiveFarm(farm);

				if (!doNotBroadcast) {
					this.$rootScope.$broadcast('farm:changed');
				}
			};
			setFirstAvailableFarmActive() {
				var availableFarms = this.getAvailableFarms();
				if(!_.isEmpty(availableFarms)){
					var nextAvailableFarm = _.first(availableFarms);
                    var activeFarmHerds = [];
					var herd = _.find(this.getAvailableHerds(),{farmId: _.get(nextAvailableFarm,'farmId')});
                    if(!_.isUndefined(herd)){
						activeFarmHerds.push(herd);
						_.set(nextAvailableFarm,'herds',herd);
					    this.setActiveFarm(nextAvailableFarm);
					}else{
						console.log("!!!! MSF->setFirstAvailableFarmActive: could not set active farm. found farm ,but not its herds !!!!!");
					}
					
				}else{
					console.log("!!!! MSF->setFirstAvailableFarmActive: could not set active farm. no available farms to set as active !!!!!");
				}
				
			}

			getActiveFarm() {
				return this.cookies.state.activeFarm;
			};
			// function that returns a promise that resolves when the farm is set , but waits at maximum 5 mins.
			getActiveFarmWithWait() {
				var maxWait = moment().add(1, 'minutes');
				var deferred = this.$q.defer();
				var interval = setInterval(() => {
					if (this.cookies.state.activeFarm && !_.isEmpty(this.cookies.state.activeFarm)) {
						clearInterval(interval);
						deferred.resolve(this.activeHerd);
					}
					if (moment().isAfter(maxWait)) {
						clearInterval(interval);
						deferred.reject(null);
					}
				}, 100);
				return deferred.promise;
			}


			getSortedListOfAvailableFarms(farms){
				var lowerCaseFarmName = (farm) => {
					return farm.name.toLowerCase();
				};

				var sorted		= _.sortBy(farms, lowerCaseFarmName);
				var testFarm	= _.find(sorted, {farmId: 1});
				sorted			= _.without(sorted, testFarm);

				if (testFarm) {
					sorted.unshift(testFarm);
				}

				return sorted;
			};

			updateAvailableFarmListOptions(){
				var updateAFLOPromise = this.$q.defer();
				if (window.navigator.onLine) {
					this.api.getFarmsByPersonId(this.cookies.user.PersonId, (err, data) => {
						if (err) {
							log.error('error getting farms by personId: ' + err);

							updateAFLOPromise.reject('error getting farms by personId: ' + err);
						}

						
						var sorted = this.getSortedListOfAvailableFarms(data);
						this.setAvailableFarms(sorted);

						this.refreshPersmissionsAndRoles();

						this.lists.availableFarms = sorted;

						this.$rootScope.$broadcast('farm:available-farms-updated');
						updateAFLOPromise.resolve(true);
					
					});
				}else{
					updateAFLOPromise.resolve(true);
				}
				
				return updateAFLOPromise.promise;
			};

			updateAvailableHerdListOptions(){
				var updateAHLOPromise = this.$q.defer();
				var farms = this.getAvailableFarms();
				var farmIds = _.map(farms,(farm)=>{return {farmId:_.get(farm,'farmId')}});
				if (window.navigator.onLine) {
					this.api.getHerdsByFarmIds(JSON.stringify(farmIds), (err, herdData) => {
						if (err) {
							log.error('error getting farms by personId: ' + err);

							
						}

						this.setAvailableHerds(herdData);

						updateAHLOPromise.resolve(true);
					});
				} else {
					
					updateAHLOPromise.resolve(true);
				}
				return updateAHLOPromise.promise;
			}
            
			updateAdditionalHerdDData(){
				var updateAHDPromise = this.$q.defer();
				var herds = this.getAvailableHerds();
				var herdIds = _.map(herds,(herd)=>{return {herdId:_.get(herd,'herdId')}});
		
				if (window.navigator.onLine) {
					this.api.getAdditionalHerdDataByHerdIds(JSON.stringify(herdIds), (err, additionalHerdData) => {
						if (err) {
							log.error('error getting AdditionalHerdData in MSF.updateAdditionalHerdDdata: ' + err);

							
						}
						if(!_.isUndefined(additionalHerdData) && !_.isNull(additionalHerdData) && !_.isEmpty(additionalHerdData)){
							var sortedAdditionalHerdData = _.sortBy(additionalHerdData,'herdId');
							this.setAdditionalHerdData(sortedAdditionalHerdData);
						}

						updateAHDPromise.resolve(true);
					});
				} else {
					
					updateAHDPromise.resolve(true);
				}
				return updateAHDPromise.promise;
			}
			
			updateAdditoinalHerdDataListOption(herdId,farmInactive = false){
			    // if the farm is inactive, we need to remove the additional herd data from local storage
				if(farmInactive){
					var additionalHerdData = this.getAdditionalHerdData();
					var filteredAdditionalHerdData = _.reject(additionalHerdData,{herdId: herdId});
					var sortedLocalStorageAdditionalHerdData = _.sortBy(filteredAdditionalHerdData,'herdId');
					this.setAdditionalHerdData(sortedLocalStorageAdditionalHerdData);
				}else{
					// otherwise, we need to add the additional herd data record to local storage if it doesn't exist
					var additionalHerdData = this.getAdditionalHerdData();
					var additionalHerdDataItem = _.find(additionalHerdData,{herdId: herdId});
					if(_.isUndefined(additionalHerdDataItem)){
						var additionalHerdDataItem = {herdId: herdId} as unknown; //TODO: establish more interfaces
						additionalHerdData.push(additionalHerdDataItem);
						var sortedAdditionalHerdData = _.sortBy(additionalHerdData,'herdId');
						this.setAdditionalHerdData(sortedAdditionalHerdData);
					}

				}
			}

			updateAvailableFarmListOption(farm,farmInactive = false){
				 // if farm is null or undefined, nothing to do here
				 if(this.isNullish(farm)){
					return;
				 }							

				var availableFarms = this.getAvailableFarms();
				if(farmInactive){
					availableFarms = _.reject(availableFarms,{farmId: _.get(farm,'farmId')});     
				}else{
					var availableFarmsItem = _.find(availableFarms,{farmId: _.get(farm,'farmId')});
					if(!_.isUndefined(availableFarmsItem)){
							var updatedAvailableFarmsItem = _.merge(availableFarmsItem,_.omit(farm,'herds'));
							var updatedAvailableFarmsItemIndex = _.findIndex(availableFarms,{farmId: _.get(farm,'farmId')});
							availableFarms[updatedAvailableFarmsItemIndex] = updatedAvailableFarmsItem;
					}else{
						availableFarms.push(farm);
						availableFarms = this.getSortedListOfAvailableFarms(availableFarms);
					}
				}
				
				this.setAvailableFarms(availableFarms);
			};

			updateAvailableHerdListOption(herd,farmInactive = false){
				if(this.isNullish(herd)){
					return;
				}

				var availableHerds = this.getAvailableHerds();
				if(farmInactive){
					availableHerds = _.reject(availableHerds,{herdId: _.get(herd,'herdId')});
				}else{
					var availableHerdsItem = _.find(availableHerds,{herdId: _.get(herd,'herdId')});
					if(!_.isUndefined(availableHerdsItem)){
						var updatedAvailableHerdsItem = _.merge(availableHerdsItem,herd);
						availableHerds = _.merge(availableHerds,updatedAvailableHerdsItem);
					}else{
						availableHerds.push(herd);
						availableHerds = _.sortBy(availableHerds, 'herdId');
					}
				}
				
				this.setAvailableHerds(availableHerds);
			};

			getAdditionalHerdDataItem(herdId){
				var additionalHerdDataItem = {};
				var additionalHerdData = this.getAdditionalHerdData();
				additionalHerdDataItem = _.find(additionalHerdData,{herdId: herdId});
				
				return additionalHerdDataItem;
			}

			setActiveHerd(herd, doNotBroadcast = false) {
				var prevHerd = _.cloneDeep(this.activeHerd);
				this.activeHerd = herd;
                this.mySynchDataStore.setActiveHerd(herd);
				this.confirmNavigationStateOnHerdChange(prevHerd,herd);
				if (!doNotBroadcast) {
					this.$rootScope.$broadcast('herd:changed');
				}
			};

			setFirstAvailableHerdActive() {
				var availableHerds = this.getAvailableHerds();
				if(!_.isEmpty(availableHerds)){
					var nextAvailableHerd = _.first(availableHerds);
					this.setActiveHerd(nextAvailableHerd);
				}
				
			}
			getActiveHerd() {
				return this.activeHerd;
			};
			
			// function that returns a promise that resolves when the herd is set, but waits at maximum 5 mins.
			getActiveHerdWithWait() {
				var maxWait = moment().add(1, 'minutes');
				var deferred = this.$q.defer();
				var interval = setInterval(() => {
					if (this.activeHerd && !_.isEmpty(this.activeHerd)) {
						clearInterval(interval);
						deferred.resolve(this.activeHerd);
					}
					if (moment().isAfter(maxWait)) {
						clearInterval(interval);
						deferred.reject(null);
					}
				}, 100);
				return deferred.promise;
			};

			setActiveHerdFertilityProgram(herdFertilityProgram, doNotBroadcast) {
				this.activeHerdFertilityProgram = herdFertilityProgram;

				if (!doNotBroadcast) {
					this.$rootScope.$broadcast('herdFertilityProgram:changed');
				}
			};

			getActiveHerdFertilityProgram() {
				return this.activeHerdFertilityProgram;
			};

			getAvailableFarms(){
				return this.availableFarms
			};
			setAvailableFarms(availableFarms){
				this.availableFarms = availableFarms;
			}
			getAvailableHerds(){
				return this.availableHerds;
			};
			setAvailableHerds(availableHerds){
				this.availableHerds = availableHerds;
			}

			getAdditionalHerdData(){
				return this.additionalHerdData;
			}
			setAdditionalHerdData(additionalHerdData){
				this.additionalHerdData = additionalHerdData;
			}
			
			confirmNavigationStateOnHerdChange(previousHerd,newHerd){
					var prevHerdHMS = _.get(previousHerd,'herdMgmtSoftware');
					var newHerdHMS = _.get(newHerd,'herdMgmtSoftware');
					if(!_.isEqual(prevHerdHMS,newHerdHMS)){
				       this.broadCastSrv.updateNavigationMsg({updateSections:[{name:"SingleFarmSection",sectionType:"SingleFarm"}]});
					}
			}

			getUserHomepageStateName(loadingRootUrl = false){
				var userDC305FarmsHPStateName = "MultiFarmDashboard";
				var userDC305FarmHPStateName = "KpiDashboard";
				var userOnlyDC305TestFarmsHPStateName = "KpiDashboard";
				var userOnlyNonDC305FarmsHPStateName = "FarmGoalManagement";
				var tmHPStateName = "TerritoryDashboard";
				var saHPStateName = "MultiFarmDashboard";

	
				var isSuperAdmin = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'));
				var isParnellViewer = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','PARNELL_VIEWER'));
				var isTM = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'));
				var isUser = (!isSuperAdmin && !isTM) ? true : false;
               
				var currentActiveHerd = this.getActiveHerd();
				if(_.isUndefined(currentActiveHerd) || _.isEmpty(currentActiveHerd)){
					currentActiveHerd = _.get(this.cookies,'state.activeFarm.herds[0]');
				}
				
				// if we are loading from the base url currentActiveHerd isn't set yet, so we override  currentActiveHerdIsDC305
				var currentActiveHerdIsDC305 = (loadingRootUrl) ? loadingRootUrl : _.isEqual(_.get(currentActiveHerd,"herdMgmtSoftware"),"DC305");
                
				if(isSuperAdmin || isParnellViewer){
					return (currentActiveHerdIsDC305) ? saHPStateName : userOnlyNonDC305FarmsHPStateName;
				}

				if(isTM){
					return (currentActiveHerdIsDC305) ? tmHPStateName : userOnlyNonDC305FarmsHPStateName;
				}

				if(isUser){
					var availableFarms = this.getAvailableFarms();
					if(availableFarms.length == 0){	
						return "User";
					}

					if(this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','VIEWER')) ){
						if( _.isEqual(_.get(currentActiveHerd,"herdMgmtSoftware"),"DC305")){
							return "KpiDashboard";
						}else{
							return "User";
						}
						 
					}
	
						var hasOnlyNonDC305Farms = this.userHasOnlyNonDC305Farms();
						
						if(hasOnlyNonDC305Farms){
							return userOnlyNonDC305FarmsHPStateName;
						}

						

						if(this.userHasTestFarmsOnly() && !hasOnlyNonDC305Farms){
							return (currentActiveHerdIsDC305) ? userOnlyDC305TestFarmsHPStateName : userOnlyNonDC305FarmsHPStateName;
						}

						if(availableFarms.length > 1){
							return (currentActiveHerdIsDC305) ? userDC305FarmsHPStateName : userOnlyNonDC305FarmsHPStateName;
						}else{
							return  userDC305FarmHPStateName;
						}


				
				}

              
			}

			// function that code safely returns a parsed local storage item or undefined if it doesn't exist
			getParsedLocalStorageItem(itemName){
				var parsedLocalStorageItem = undefined;
				var localStorageItem = localStorage.getItem(itemName);
				if(!_.isNull(localStorageItem)){
					try{
						parsedLocalStorageItem = JSON.parse(localStorageItem);
					}catch(e){
						console.log("Failed to parse localStorageItem in MSF.getParsedLocalStorageItem()");
					}
				}
				return parsedLocalStorageItem;
			}
			

			// function that parses latestCowfileSizesJson on the current active herd and returns the newest latestCowfileSizesJson record
			getLatestCowfileSizesJsonObj(){
				var latestCowfileSizesJsonObj = undefined;
				var currentActiveHerd = this.getActiveHerd();
				if(!_.isUndefined(currentActiveHerd) && !_.isEmpty(currentActiveHerd)){
					var latestCowfileSizesJson = _.get(currentActiveHerd,'latestCowfileSizesJson',"[]");
					if(!_.isUndefined(latestCowfileSizesJson)){
						try{
							var latestCowfileSizesJsonCollection = JSON.parse(latestCowfileSizesJson);
							latestCowfileSizesJsonObj = _.max(latestCowfileSizesJsonCollection,(latestCowfileSizesJsonObj)=>{
								return  moment(_.get(latestCowfileSizesJsonObj,'AddDate')).toDate();
								});
						}catch(e){
							console.log("Failed to parse latestCowfileSizesJson in MSF.getLatestCowfileSizesJsonObj()");
						}
					}
				}
				return latestCowfileSizesJsonObj;
			}


           // this function is used to determine if the current farm's data is out of date
			farmDataIsOutOfDate(){
				var outOfDateObj = {
					outOfDate: false,
					metaLastEventDate: null,
				}
				var deferred = this.$q.defer();

				this.getActiveHerdWithWait().then((activeHerd)=>{

						
                 
						var currentActiveHerdAdditionalHerdData = this.getAdditionalHerdDataItem(_.get(activeHerd,'herdId'));
						var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
						var metaLastEventDate  = !_.isUndefined(metaLastEventDateString) && !_.isNull(metaLastEventDateString) ? moment(metaLastEventDateString).toDate() : null;
						var outofdateDataCodeFileItem = this.getParsedCodeFileItemByCodeAndCodeType('SITEMODALCONFIGS','OUTOFDATEDATA')
						var numDaysOldLimit = _.get(outofdateDataCodeFileItem,'details.numDaysOldLimit',13);

						_.set(outOfDateObj,'metaLastEventDate',metaLastEventDate);
							
						
						// the latest cow event date is > than numDaysOldLimit days ago, then the data is out of date
						if(_.isNull(metaLastEventDate) || moment().diff(metaLastEventDate,'days') > numDaysOldLimit){
							_.set(outOfDateObj,'outOfDate',true);
						}
						deferred.resolve(outOfDateObj);
					
					
				},(error)=>{
					console.log("Failed to get active herd in MSF.farmDataIsOutOfDate(): "+error);
					deferred.resolve(outOfDateObj);
				});
			  
				return deferred.promise;
			}

			getActiveUser(){
				return _.get(this.cookies,'user');
			}
			getUserFullName(){
				var user = this.getActiveUser();
				return _.get(user,'FirstName','') + " " + _.get(user,'LastName','');
			}

			currentUserIsDemoUser(){
				var currentUser = this.getActiveUser();
				return _.get(currentUser,'IsDemoUser',false);
			}


			userHasOnlyNonDC305Farms(){
				var availableHerds = this.getAvailableHerds();

				var hasOnlyNonDC305Farms = _.all(availableHerds,(herd) =>{
											 return !_.isEqual(_.get(herd,'herdMgmtSoftware'),"DC305");
										});
				return hasOnlyNonDC305Farms;	
			}

			userHasTestFarmsOnly(){
				var availableFarms = this.getAvailableFarms();
				var hasOnlyTestFarms = _.all(availableFarms,(farm) =>{
											 return _.isEqual(_.get(farm,'isTestFarm'),true);
										});
				return hasOnlyTestFarms;						
			};

			touchForm(form) {
				angular.forEach(form.$error,	(field) => {
					angular.forEach(field,		(errorField) => {
						errorField.$setTouched();
					});
				});
			};

			loadPage(page, optionalParams:object = {}) {
				this.state.go(page, optionalParams);
				this.$anchorScroll();
				  var pageType = this.getPageTypeByState(page); 
				 // console.log("############### setCurrentPageType was called from MSF Load Page ###############");
				  this.mySynchDataStore.setCurrentPageType(pageType);
			};

			loadPageForFarmId(page,herdId,farmId,changingView = false,viewType = "",doNotBroadcastFarm = false,doNotBroadcastHerd = false){
				
				
				this.$rootScope.$broadcast("farm-herd:pre-farm-select",{farmId: farmId});
				this.broadCastSrv.sendFarmPreSelectMsg({farmId: farmId});
				this.setActiveFarmAndHerdState(herdId,farmId,changingView,viewType,doNotBroadcastFarm,doNotBroadcastHerd).then((farmAndHerdIsSet) =>{
				   if(farmAndHerdIsSet){
					this.loadPage(page); 
				  }     
			   });
			   
			};

			setActiveFarmAndHerdState(herdId,farmId,changingView = false,viewType = "",doNotBroadcastFarm = false,doNotBroadcastHerd = false){
			   var setActiveFarmAndHerdStatePromise = this.$q.defer();  		
			   this.api.getHerd(herdId, null, (err,herdData) => {
					  if(!_.isUndefined(_.get(herdData,'herdId'))){
						 var herd = _.cloneDeep(herdData);

						

						 this.api.getFarm(farmId,(err,farmData) =>{
							   
							 var farm = _.cloneDeep(farmData);

							 if(!_.isUndefined(_.get(farmData,'farmId'))){
							 

								this.api.getHerdsByFarmId(farmId,(err,farmHerdsData) => {
									
									var selectedFarm = _.cloneDeep(farm);
									_.set(selectedFarm,'herds',farmHerdsData);
									
									this.setActiveFarm(selectedFarm,doNotBroadcastFarm);
									this.setActiveHerd(herd,doNotBroadcastHerd);
									
									if(_.isEqual(changingView,true)){
										this.$rootScope.$broadcast("farm-herd:change-view",{viewType: viewType});
									}    
									this.$rootScope.$broadcast("farm-herd:changed",{herd:herd,farm:farm,farmHerds:farmHerdsData});
									this.broadCastSrv.sendHerdChangeMsg({herd:herd,farm:farm,farmHerds:farmHerdsData});
									setActiveFarmAndHerdStatePromise.resolve(true);
								});
							}else{
								setActiveFarmAndHerdStatePromise.resolve(false);
							}

						 });
							 
							   
					  }else{
						setActiveFarmAndHerdStatePromise.resolve(false);
					  }

					 
				});  
				return setActiveFarmAndHerdStatePromise.promise;
			};

			

			confirm(options, confirmCallback, cancelCallback) {
				this.$rootScope.$broadcast('message:confirmation', options, confirmCallback, cancelCallback);
			}

			loadFarmsAfterLogin(done) {
				async.auto(this.postLoginApiFunctions, done);
			};

			logout(callback) {
				this.api.logout({}, (err, data) => {
					this.cookies.user = {};
					this.cookies.save();
					this.setActiveFarm(null);
					this.setActiveHerd(null);
					this.lists.availableFarms = [];
					this.$rootScope.$broadcast('user:changed', {event: null});
					this.mySynchDataStore.onUserChanged(this.cookies.user);

					if (_.isFunction(callback)) {
						callback();
					}
				});
			};

			logoutWithMessage(messageType,message) {
				this.api.logout({}, (err, data) => {
					this.cookies.user = {};
					this.cookies.save();
					this.setActiveFarm(null);
					this.setActiveHerd(null);
					this.lists.availableFarms = [];
					this.$rootScope.$broadcast('user:changed', {event: null});
					this.mySynchDataStore.onUserChanged(this.cookies.user);

					switch (messageType) {
						case "info":
							this.confirmation.info(message,false);
							break;
						case "success":
							this.confirmation.success(message,false);
							break;
						case "warning":
							this.confirmation.warning(message,false);
							break;
						case "danger":
							this.confirmation.danger(message,false);
							break;
					
						default:
							this.confirmation.info(message,false);
							break;
					}

					this.loadPage("Login");
				});
			};
			getPageTypeByState(state){
				return (!_.includes(_.union(this.multiFarmStates,this.adminStates),state)) ? "SingleFarm" : _.includes(this.multiFarmStates,state) ? "MultiFarm" : "Admin" ;
			}
			getPBIServicesUrl(){
				return this.buildPBIServicesUrl();
			};
			
			getEnvironmentName(){
				return this.buildEnvironmentName();
			};
			isLocalOrDevelopmentEnvironment(){
				const environmentName = this.buildEnvironmentName();
				return _.includes(['LOCAL','DEV'],environmentName);
			}

			lowerCaseObjectKeys(upperCaseObj){
				if (!_.isObject(upperCaseObj)) {
					return upperCaseObj;
				}

				return _.reduce(upperCaseObj, (result, value, key) => {
					key = key.charAt(0).toLowerCase() + key.slice(1);
					result[key] = value;

					return result;
				}, {});
			};

			lowerCaseObjectOfCollections(objOfCollections){
				return _.forOwn(objOfCollections, (listArray, listKey) => {
					objOfCollections[listKey] = _.map(listArray, this.lowerCaseObjectKeys);
				});
			};
			
			upperCaseObjectKeys(lowerCaseObj){
				if (!_.isObject(lowerCaseObj)) {
					return lowerCaseObj;
				}

				return _.reduce(lowerCaseObj, (result, value, key) => {
					key = key.charAt(0).toUpperCase() + key.slice(1);
					result[key] = value;

					return result;
				}, {});
			};

			upperCaseObjectOfCollections(objOfCollections){
				return _.forOwn(objOfCollections,(listArray, listKey) => {
					objOfCollections[listKey] = _.map(listArray, this.upperCaseObjectKeys);
				});
			};


		//	this promise is resolved when the async calls are done
		ready(success, error) {
			this.msfReady.then(success);
		};

}
angular.module('mySynch').service('MySynchFactory', MySynchFactory );

